import { PUBLIC_API_URL } from '$env/static/public';

import type { ApprovalResponse } from '../types';

export const requestApproval = async (orderId: string, buyerAddress: string): Promise<ApprovalResponse> => {
  const response = await fetch(`${PUBLIC_API_URL}/market/sale-orders/${orderId}/approve?buyer_address=${buyerAddress}`);

  return response.json();
};
